<template>

  <div class="ads-query">

    <form action="#">

      <div v-for="(category,index) in categories">
        <label>{{ translateColumn(category.columnName) }}</label>
        <MultiSelect :allOption="true" many="selected"
                     :options="category.options" :value="selectedCategories[index].options"
                     @update:value="(...args) => updateCategories(index, ...args)"></MultiSelect>
      </div>

      <div class="check-box" v-on:click="toggleAggregateUrls">
        <span>
          <i v-if="aggregateUrls" class="material-icons">check_box</i>
          <i v-if="!aggregateUrls" class="material-icons">check_box_outline_blank</i>
        </span>
        <span>{{ i18n().aggregateUrls }}</span>
      </div>

    </form>
  </div>

</template>

<script>
import adsAnalyzer from "../../logic/adsAnalyzer"
import MultiSelect from "../utils/MultiSelect.vue"
import i18n from "i18n"

export default {
  name: 'ads-query',
  components: { MultiSelect },
  props: {
    columns: {
      type: Array
    },
    categories: {
      type: Array
    },
    query: {
      type: Object,
      default() {
        return {
          categories: 'all',
          aggregateUrls: true
        }
      }
    }
  },
  data () {
    //console.error("DEFAULT WC", this.query)
    return {
      aggregateUrls: this.query.aggregateUrls,
      selectedCategories: []
    }
  },
  computed: {
  },
  watch: {
    categories() {
      this.selectedCategories = JSON.parse(JSON.stringify(this.categories))
    },
    query(q) {
      this.aggregateUrls = this.query.aggregateUrls
      this.selectedCategories = (!this.query.categories || this.query.categories == 'all')
                                ? JSON.parse(JSON.stringify(this.categories))
                                : JSON.parse(JSON.stringify(this.query.categories))
    },
    aggregateUrls(v) {
      let query = JSON.parse(JSON.stringify(this.query))
      query.aggregateUrls = v
      this.$emit("update:query", query)
    },
  },
  methods: {
    i18n() {
      return i18n().ads.query
    },
    translateColumn(col) {
      return i18n().translateColumnName(col)
    },
    toggleAggregateUrls() {
      this.aggregateUrls = ! this.aggregateUrls;
    },
    updateCategories(index, value) {
      this.selectedCategories[index].options = value
      let query = JSON.parse(JSON.stringify(this.query))
      query.categories = JSON.parse(JSON.stringify(this.selectedCategories))
      this.$emit("update:query", query)
    }
  },
  created() {
    this.selectedCategories = JSON.parse(JSON.stringify(this.categories))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .mdl-selectfield {
    width: 12em;
    padding-top: 0.23em;
    padding-bottom: 1.0em;
  }
  .mdl-textfield {
    width: 12em;
    padding-top: 0.23em;
    padding-bottom: 1.0em;
  }

  h8 {
    margin: 0;
  }
  .mdl-selectfield {

  }

  .range-to {
    display: block;
    float: left;
    margin-right: 1em;
    top: 8px;
    vertical-align: bottom;
    position: relative;
  }

  .mdl-textfield {
    width: 4em;
    float: left;
    margin-right: 1em;
    vertical-align: baseline;
  }
  .mdl-textfield input {
    text-align: center;
  }

  .mdl-selectfield:before {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid black;
    content:"";
    position: relative;
    float: right;
    top: 15px;
    right: 3px;
  }

  .nice-select {
    position: relative;
    border: none;
    border-bottom: 1px solid rgba(0,0,0,.12);
    display: block;
    font-size: 16px;
    font-family: "Helvetica","Arial",sans-serif;
    margin: 0;
    padding: 4px 0;
    width: 100%;
    background: 0 0;
    text-align: left;
    color: inherit;
  }

  .nice-select > span {
    display: block;
    position: absolute;
    right: 0;
    top: 10%;
  }

  .nice-selectfield {
    font-size: 16px;
    display: inline-block;
    box-sizing: border-box;
    width: 300px;
    max-width: 100%;
    margin: 0;
    padding: 10px 0;
  }

  .nice-selectfield .mdl-menu {
    max-height: 320px;
    overflow-y: auto;
  }

  .nice-selectfield .mdl-menu__container {
    max-width: 200px;
  }
  .nice-select {
    text-overflow: ellipsis;
  }
  .nice-selectfield .mdl-menu__item {
    max-width: 165px;
    text-overflow: ellipsis;
  }
  .nice-selectfield .mdl-menu__item .material-icons {
    position: relative;
    top: 7px;
  }

  #word-column {
    width: 90%;
  }

  .check-box {
    cursor: default;
  }
  .check-box i {
    position: relative;
    top: 6px;
  }

</style>



// WEBPACK FOOTER //
// AdsQuery.vue?2cbb52c2